<script setup lang="ts">
const { color = "light", isCollapsable = true } = defineProps<{
  isOpen?: boolean;
  isCollapsable?: boolean;
  name: string;
  color?: "dark" | "light";
}>();

const emit = defineEmits(["toggle"]);
</script>

<template>
  <details @toggle="emit('toggle')" class="collapsible" :open="isOpen" :name>
    <summary
      :class="[
        'collapsible__header',
        `collapsible__header--${color}`,
        isCollapsable ? '' : 'collapsible__header--static',
      ]"
    >
      <slot name="header" />
      <SvgoChevronRight
        v-if="isCollapsable"
        :class="[
          'collapsible__header__icon',
          `collapsible__header__icon--${color}`,
        ]"
      />
    </summary>

    <slot name="content" />
  </details>
</template>

<style lang="scss" scoped>
@use "@citizenm/lobby/assets/styles/utils/mixins" as mixins;

.collapsible {
  &__header {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-family: var(--font-family-bold, sans-serif);
    line-height: 1.5;
    border-bottom: 1px solid var(--primary-white, #fff);

    &--dark {
      &:hover {
        color: var(--primary-red, #ff0038);
        cursor: pointer;
      }
    }

    &__icon {
      width: 1rem;
      height: 1rem;
      transform: rotate(90deg);
      transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);

      &--light {
        svg {
          fill: var(--primary-white, #fff);
        }
      }

      &--dark {
        svg {
          fill: var(--primary-black, #000);
        }
      }
    }

    &--static {
      pointer-events: none;
    }
  }

  &[open] {
    .collapsible__header {
      margin-bottom: var(--space-24, 24px);

      &__icon {
        transform: rotate(-90deg);
      }
    }
  }

  summary {
    list-style-type: none;

    @include mixins.md {
      // pointer-events: none;
    }
  }
}
</style>
